export const NAME: number = 1;
export const CUSTOMER: number = 2;
export const DATE: number = 3;
export const TOTAL: number = 4;
export const NUMBER: number = 5;
